export const notificationResponses = {
  need_to_do: [
    {
      client: "Pertamina",
      title: "Prepare for the upcoming Client Meeting on January 24th",
      description:
        "You have a meeting with Emma Sri Martini, Director of finance. Please visit the dashboard to summarize points for the meeting.​",
      due_date: "24th January​",
    },
    {
      client: "PTPM",
      title:
        "Schedule a follow-up meeting with PTPM to discuss overdue payments",
      description:
        "Discuss the reasons for delayed payments and potential impacts on the client’s credit profile. Explore short-term options to ease repayment pressures.​​",
      due_date: "28th January​",
    },
  ],
  need_to_know: [
    {
      client: "Pertamina",
      title: "Company’s Quarterly Results have been declared​",
      description: "Pertamina has declared its financial results for Q3FY24​​​",
    },
  ],
  good_to_know: [
    {
      client: "Pertamina",
      title: "Company’s Quarterly Results have been declared​",
      description: "Pertamina has declared its financial results for Q3FY24​​​",
    },
  ],
};
